<template>
  <app-layout>
    <template #header>
      <div class="text-center print:text-left">
        <h1 class="text-2xl">Leergutreklamation</h1>
        <p class="text-base">Für meine Bestellung vom <b>{{ $page.props.formattedOrderDate }}</b>, KW {{ $page.props.weekOfYear }}</p>
        <Link :href="route('complaint-index', { order: $page.props.order })" class="button-secondary ml-auto mt-8 print:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
          </svg>
          Zurück
        </Link>
      </div>
      <div class="max-w-4xl mx-auto px-4 md:px-6 text-left my-8">
        <table class="w-full mb-12">
          <tbody>
            <tr>
              <td>Übermittelt am</td>
              <td class="text-right">{{ this.$page.props.submittedAt }} Uhr</td>
            </tr>
          </tbody>
        </table>
        <table class="w-full my-8">
          <thead>
            <tr>
              <th class="w-2/6 pb-2 text-accent-brown print:text-sm print:w-full">Artikelname</th>
              <th class="w-2/6 text-right pb-2 text-accent-brown print:text-sm print:w-16">Differenz</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in this.$page.props.products"
              :key="product.id">
              <td class="text-left py-4 border-b border-gray-300 print:border-black right text-lg print:py-1 print:text-sm">{{ product.name }} ({{ product.item_number }})</td>
              <td class="text-right py-4 border-b border-gray-300 print:border-black text-lg print:py-1 print:text-sm">{{ product.difference }}</td>
            </tr>
          </tbody>
        </table>

        <h4 class="w-full print:max-w-none mx-auto text-lg mb-6 font-bold print:text-base print:mb-2">Kommentar:</h4>
        <div v-if="this.$page.props.message">{{ this.$page.props.message }}</div>
        <div v-else>-</div>
      </div>
    </template>
  </app-layout>
</template>

<script>
import{ Link } from "@inertiajs/inertia-vue3"

import AppLayout from '@/Layouts/AppLayout'

export default {
  components: {
    AppLayout,
    Link
  },
}
</script>
